export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor x Pallet"])},
          "packages_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar packing list"])}
        }
      }
    }
  })
}